import React, {useState} from "react";
import {Row,Col} from "reactstrap";

import Faq1 from "./Text12-faqs/faq1";
import Faq2 from "./Text12-faqs/faq2";
import Faq3 from "./Text12-faqs/faq3";
import Faq4 from "./Text12-faqs/faq4";
import Faq5 from "./Text12-faqs/faq5";
import Faq6 from "./Text12-faqs/faq6";
import Faq7 from "./Text12-faqs/faq7";
import Faq8 from "./Text12-faqs/faq8";
import Faq9 from "./Text12-faqs/faq9";
import Faq10 from "./Text12-faqs/faq10";

const Text12 = () =>{

  React.useEffect(() => {
    // 👇️ scroll to top on page load, behavior can be snappy with 'auto'
    document.getElementById('top')?.scrollIntoView({ behavior: 'smooth' });}
    , []);

    const [faq,setFaq] = useState('1.0');

  return(
    <>
      <p className="content-heading" id="top">
        Frågor & Svar
      </p>

      <Row className="content-text mt-4">
        <Col
          xs={20}
        >
          <ol className="ps-0">
            <li 
              className={ faq === '1.0' ? 'faq-navlink-focused' : 'faq-navlink'}
              onClick={()=>setFaq('1.0')}
            > 
              Vad går <i>din</i>BiZ-analysen ut på? 
            </li>
            <li 
              className={ faq === '2.0' ? 'faq-navlink-focused' : 'faq-navlink'}
              onClick={()=>setFaq('2.0')}
            > 
              Var börjar jag? 
            </li>
            <li 
              className={ faq === '3.0' ? 'faq-navlink-focused' : 'faq-navlink'}
              onClick={()=>setFaq('3.0')}
            > 
              Hur avläser jag analys-resultat? 
            </li>
            <li 
              className={ faq === '4.0' ? 'faq-navlink-focused' : 'faq-navlink'}
              onClick={()=>setFaq('4.0')}
            > 
              Hur vet jag att <i>din</i>BiZ-analysen är färdig? 
            </li>
            <li 
              className={ faq === '5.0' ? 'faq-navlink-focused' : 'faq-navlink'}
              onClick={()=>setFaq('5.0')}
            > 
              Hur vet jag vilken bolagsform som blir fördelaktigast? 
            </li>
            <li 
              className={ faq === '6.0' ? 'faq-navlink-focused' : 'faq-navlink'}
              onClick={()=>setFaq('6.0')}
            > 
              Hur sänker jag kostnadsmassan? 
            </li>
            <li 
              className={ faq === '7.0' ? 'faq-navlink-focused' : 'faq-navlink'}
              onClick={()=>setFaq('7.0')}
            > 
              Vad är täckningsbidrag och hur används det?
            </li>
            <li 
              className={ faq === '8.0' ? 'faq-navlink-focused' : 'faq-navlink'}
              onClick={()=>setFaq('8.0')}
            > 
              Vad är täckningsgrad och hur används det?
            </li>
            <li 
              className={ faq === '9.0' ? 'faq-navlink-focused' : 'faq-navlink'}
              onClick={()=>setFaq('9.0')}
            > 
              Hur hanteras del av tjänstetimme?
            </li>
            <li 
              className={ faq === '10.0' ? 'faq-navlink-focused' : 'faq-navlink'}
              onClick={()=>setFaq('10.0')}
            > 
              Vad innebär års-täckningsbidrag?
            </li>
          </ol>
        </Col>

        <Col
          xs={20}
          className="content-text"
        >          
          {     
              faq === '1.0' ? ( <Faq1 /> )
            : faq === '2.0' ? ( <Faq2 /> )      
            : faq === '3.0' ? ( <Faq3 /> )   
            : faq === '4.0' ? ( <Faq4 /> ) 
            : faq === '5.0' ? ( <Faq5 /> )
            : faq === '6.0' ? ( <Faq6 /> )
            : faq === '7.0' ? ( <Faq7 /> )
            : faq === '8.0' ? ( <Faq8 /> )
            : faq === '9.0' ? ( <Faq9 /> )
            : faq === '10.0' ? ( <Faq10 /> )
            : ('')
          }               
        </Col>
        
      </Row>
    </>
  );
}
export default Text12;